// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { EntityTypeId } from '../tbs/entity-type-id.js';


export class RownipulatorAddRowAction implements flatbuffers.IUnpackableObject<RownipulatorAddRowActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):RownipulatorAddRowAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsRownipulatorAddRowAction(bb:flatbuffers.ByteBuffer, obj?:RownipulatorAddRowAction):RownipulatorAddRowAction {
  return (obj || new RownipulatorAddRowAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsRownipulatorAddRowAction(bb:flatbuffers.ByteBuffer, obj?:RownipulatorAddRowAction):RownipulatorAddRowAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new RownipulatorAddRowAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapRownipulatorAddRow;
}

etypeIds(index: number):EntityTypeId|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb!.__vector(this.bb_pos + offset) + index * 2) : null;
}

etypeIdsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

etypeIdsArray():Uint16Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? new Uint16Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

heading():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

static startRownipulatorAddRowAction(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapRownipulatorAddRow);
}

static addEtypeIds(builder:flatbuffers.Builder, etypeIdsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, etypeIdsOffset, 0);
}

static createEtypeIdsVector(builder:flatbuffers.Builder, data:EntityTypeId[]):flatbuffers.Offset {
  builder.startVector(2, data.length, 2);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt16(data[i]!);
  }
  return builder.endVector();
}

static startEtypeIdsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(2, numElems, 2);
}

static addHeading(builder:flatbuffers.Builder, heading:number) {
  builder.addFieldInt32(2, heading, 0);
}

static endRownipulatorAddRowAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createRownipulatorAddRowAction(builder:flatbuffers.Builder, type:ActionType, etypeIdsOffset:flatbuffers.Offset, heading:number):flatbuffers.Offset {
  RownipulatorAddRowAction.startRownipulatorAddRowAction(builder);
  RownipulatorAddRowAction.addType(builder, type);
  RownipulatorAddRowAction.addEtypeIds(builder, etypeIdsOffset);
  RownipulatorAddRowAction.addHeading(builder, heading);
  return RownipulatorAddRowAction.endRownipulatorAddRowAction(builder);
}

unpack(): RownipulatorAddRowActionT {
  return new RownipulatorAddRowActionT(
    this.type(),
    this.bb!.createScalarList<EntityTypeId>(this.etypeIds.bind(this), this.etypeIdsLength()),
    this.heading()
  );
}


unpackTo(_o: RownipulatorAddRowActionT): void {
  _o.type = this.type();
  _o.etypeIds = this.bb!.createScalarList<EntityTypeId>(this.etypeIds.bind(this), this.etypeIdsLength());
  _o.heading = this.heading();
}
}

export class RownipulatorAddRowActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapRownipulatorAddRow,
  public etypeIds: (EntityTypeId)[] = [],
  public heading: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const etypeIds = RownipulatorAddRowAction.createEtypeIdsVector(builder, this.etypeIds);

  return RownipulatorAddRowAction.createRownipulatorAddRowAction(builder,
    this.type,
    etypeIds,
    this.heading
  );
}
}
